// External Dependencies:
import React from 'react'

class ErrorBoundary extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			hasError: false
		}
	}

	componentDidCatch( error, info ) {
		this.setState({
			hasError: true
		})

		console.log( error, 'error' );
		console.log( info, 'info' );
	}

	render() {
		if ( this.state.hasError ) {
			return (
				<div className="site-notice is-open">
					<p>Error.</p>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./components/ErrorBoundary/ErrorBoundary.jsx